import getReplacedAliasString from "./get-replaced-alias-string";

/**
 * Replace matches
 * @param {Map<String, Array<String>>} matches
 */
const replaceAliases = (matches) => {
  const replaced = new Map();

  /** Loop trough all matched attributes */
  for (const [attribute, aliases] of matches) {
    replaced.set(attribute, getReplacedAliasString(aliases, attribute));
  }

  return replaced;
};

export default replaceAliases;
